import React from 'react';

export const Toggle = (props: { onChange: (state: boolean) => void, state: boolean, children: any }) => 
    <button className={props.state && 'toggle-button--on' || ''} onClick={() => props.onChange(!props.state)}>{props.children}</button>